module.exports = __webpack_public_path__ + "static/img/vr8.7d3045e6.png";